// extracted by mini-css-extract-plugin
export default {"modalText":"IsolationsOptions_modalText__hr6SG","iconContainer":"IsolationsOptions_iconContainer__sL+iR","icon":"IsolationsOptions_icon__O4HP3"};